import { render, staticRenderFns } from "./BundlePurchaseContainer.vue?vue&type=template&id=80667468&"
import script from "./BundlePurchaseContainer.vue?vue&type=script&lang=ts&"
export * from "./BundlePurchaseContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports